module.exports = __webpack_public_path__ + "img/daiban.7b3e4a72.png";